export enum TAG_COLOR {
  GREEN = 'GREEN',
  TEAL = 'TEAL',
  BLUE = 'BLUE',
  PURPLE = 'PURPLE',
  RED = 'RED',
  ORANGE = 'ORANGE',
  YELLOW = 'YELLOW',
  GREY = 'GREY'
}

export interface ISearchTagsResponse {
  id: string;
  name: string;
  color: TAG_COLOR;
}

export interface ICreateLoadTag {
  name?: string;
  loadId: string;
  tripId?: string;
  tagId?: string;
}

export interface ITagAttributes {
  id?: string;
  name: string;
  color: TAG_COLOR;
  tenant_id: string;
  created_by?: string;
  updated_by?: string;
  deleted_by?: string;
}

export interface IEditLoadTag {
  tagId: string;
  name?: string;
  color?: TAG_COLOR;
}

export interface IRemoveTagLoad {
  loadId: string;
  tagId: string;
}

// Picker is used for the color picker component
// Text, background, and border are used for the Chip component
export const TagsPalette = {
  GREEN: {
    picker: '#49CF32',
    text: '#4AB637',
    background: '#eef8ed',
    border: 'rgba(74, 182, 55, 0.30)'
  },
  TEAL: {
    picker: '#24C0BA',
    text: '#2AA9A4',
    background: '#eaf9f8',
    border: 'rgba(51, 190, 184, 0.30)'
  },
  BLUE: {
    picker: '#5C6AF6',
    text: '#3A4DE9',
    background: '#eceefd',
    border: 'rgba(58, 77, 233, 0.30)'
  },
  PURPLE: {
    picker: '#CB5EFF',
    text: '#CA34FF',
    background: '#faedff',
    border: 'rgba(202, 52, 255, 0.30)'
  },
  RED: {
    picker: '#FA3636',
    text: '#DB3838',
    background: '#fbeded',
    border: 'rgba(219, 56, 56, 0.30)'
  },
  ORANGE: {
    picker: '#FD881B',
    text: '#FB923C',
    background: '#fef5ee',
    border: 'rgba(251, 146, 60, 0.30)'
  },
  YELLOW: {
    picker: '#FBC607',
    text: '#E9B600',
    background: '#fefaec',
    border: 'rgba(255, 201, 10, 0.50)'
  },
  GREY: {
    picker: '#D1D5DB',
    text: '#6B7280',
    background: '#F9FAFB',
    border: '#D1D5DB'
  }
};
